export type DetectedChapter = {
  sourcePath: string;
  bookHint: string | null;
  chapterNumber: number | null;
  title: string;
  heading: string;
  fingerprint: string;
};

const CHAPTER_RE =
  /^#\s*(?:CHAPITRE|Chapitre)\s+(\d+)\s*[-–—:]\s*(.+?)\s*$/i;

export function detectChapters(markdown: string, sourcePath: string): DetectedChapter[] {
  const bookHint = inferBook(sourcePath);
  const found: DetectedChapter[] = [];
  const lines = markdown.split(/\r?\n/);
  for (const line of lines) {
    const m = line.match(CHAPTER_RE);
    if (!m) continue;
    const chapterNumber = Number(m[1]);
    const title = m[2].trim();
    found.push({
      sourcePath,
      bookHint,
      chapterNumber: Number.isFinite(chapterNumber) ? chapterNumber : null,
      title,
      heading: line.trim(),
      fingerprint: `${sourcePath}::${chapterNumber}::${title.toLowerCase()}`,
    });
  }
  return found;
}

function inferBook(path: string): string | null {
  const p = path.toLowerCase();
  if (p.includes("tome_1") || p.includes("aube")) return "book:tome-1";
  if (p.includes("tome_2") || p.includes("fragments")) return "book:tome-2";
  if (p.includes("tome_3")) return "book:tome-3";
  return null;
}

export type ChapterProposal = {
  kind: "moment";
  status: "verify";
  fingerprint: string;
  bookId: string | null;
  chapterNumber: number | null;
  title: string;
  existingMomentId: string | null;
  note: string;
};

export function proposeMomentsFromChapters(
  detected: DetectedChapter[],
  existing: Array<{ id: string; bookId: string; chapterNumber: number }>,
): ChapterProposal[] {
  return detected.map((ch) => {
    const existingMoment = existing.find(
      (m) =>
        (ch.bookHint == null || m.bookId === ch.bookHint) &&
        m.chapterNumber === ch.chapterNumber,
    );
    return {
      kind: "moment",
      status: "verify",
      fingerprint: ch.fingerprint,
      bookId: ch.bookHint,
      chapterNumber: ch.chapterNumber,
      title: ch.title,
      existingMomentId: existingMoment?.id ?? null,
      note: existingMoment
        ? `Moment déjà présent (${existingMoment.id}). Nouvelle version à comparer, pas d’écrasement automatique.`
        : "Proposition de moment à créer après relecture humaine.",
    };
  });
}
